import { DetectionRuleSeverity } from '../api/finding.model';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const AiSeveritySelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.FindingSeverity.toString()}-${DetectionRuleSeverity.critical}`,
    value: DetectionRuleSeverity.critical,
    displayName: DetectionRuleSeverity.critical,
    filterType: FilterTypesEnum.FindingSeverity,
    categoryName: FilterTypesEnum.FindingSeverity.toString(),
  },
  {
    id: `${FilterTypesEnum.FindingSeverity.toString()}-${DetectionRuleSeverity.high}`,
    value: DetectionRuleSeverity.high,
    displayName: DetectionRuleSeverity.high,
    filterType: FilterTypesEnum.FindingSeverity,
    categoryName: FilterTypesEnum.FindingSeverity.toString(),
  },
  {
    id: `${FilterTypesEnum.FindingSeverity.toString()}-${DetectionRuleSeverity.medium}`,
    value: DetectionRuleSeverity.medium,
    displayName: DetectionRuleSeverity.medium,
    filterType: FilterTypesEnum.FindingSeverity,
    categoryName: FilterTypesEnum.FindingSeverity.toString(),
  },
  {
    id: `${FilterTypesEnum.FindingSeverity.toString()}-${DetectionRuleSeverity.low}`,
    value: DetectionRuleSeverity.low,
    displayName: DetectionRuleSeverity.low,
    filterType: FilterTypesEnum.FindingSeverity,
    categoryName: FilterTypesEnum.FindingSeverity.toString(),
  },
  {
    id: `${FilterTypesEnum.FindingSeverity.toString()}-${DetectionRuleSeverity.informational}`,
    value: DetectionRuleSeverity.informational,
    displayName: DetectionRuleSeverity.informational,
    filterType: FilterTypesEnum.FindingSeverity,
    categoryName: FilterTypesEnum.FindingSeverity.toString(),
  },
];
